import { api } from "@/api";
import type {
  IJointBillServiceProviderBillPlan,
  IJointBillServiceProviderBillPlanRequest,
  ISelectedJointBillServiceProviderBillPlan,
  IUpdateJointBillServiceProviderBillPlanRequest,
} from "./types";

export const getJointBillServiceProviderBillPlans = async (
  data: IJointBillServiceProviderBillPlanRequest,
) =>
  (
    await api.get<IJointBillServiceProviderBillPlan[]>(
      "/joint-bill-service-provider-bill-plans",
      { headers: { jointBillServiceId: data.jointBillServiceId } },
    )
  ).data;

export const updateJointBillServiceProviderBillPlan = async (
  data: IUpdateJointBillServiceProviderBillPlanRequest,
) => {
  await api.put(`/joint-bill-service-provider-bill-plans`, data);
};

export const getSelectedJointBillServiceProviderBillPlans = async () =>
  (
    await api.get<ISelectedJointBillServiceProviderBillPlan>(
      "/joint-bill-service-provider-bill-plans/selected",
    )
  ).data;
